import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt, FaWhatsapp  } from "react-icons/fa";
import { IoMailOpenOutline } from "react-icons/io5";


const FooterSection = () => {
  return (
    <div>

<div className="footer-Credentials">
  <h4 className="footer-cred-title">INDUSTRY CREDENTIALS</h4>

  <div className="footer-cred-minimal">
  <div className="cred-item">
    <a href="https://gaehp.com" target="_blank" rel="noreferrer">
      <img src="/Images/tour/Icons/logo-1.png" alt="GAEHP Membership" />
    </a>
    <p>
      Registered member of GAEHP, reflecting global hospitality and travel
      compliance standards.
    </p>
    <a
      href="https://gaehp.com/member/plenary-holidays/"
      target="_blank"
      rel="noreferrer"
      className="cred-link"
    >
      View Details →
    </a>
  </div>
  <div className="cred-item">
    <a href="https://www.adtoi.in" target="_blank" rel="noreferrer">
      <img src="/Images/tour/Icons/logo-2.jpg" alt="ADTOI Membership" />
    </a>
    <p>
      Approved ADTOI member, committed to ethical and quality domestic travel
      services in India.
    </p>
    <a
      href="https://www.adtoi.in/tour-operator-details.php?tour=768&agency=Plenary%20Holidays"
      target="_blank"
      rel="noreferrer"
      className="cred-link"
    >
      View Details →
    </a>
  </div>
  <div className="cred-item">
    <a href="#" rel="noreferrer">
      <img
        src="/Images/Icons/haryana_tourism.jpeg"
        alt=" Haryana Tourism Club"
      />
    </a>
    <p>Registered member of Haryana Tourism Club</p>
    <a href="#" rel="noreferrer" className="cred-link">
      View Details →
    </a>
  </div>
  <div className="cred-item">
    <a href="#" rel="noreferrer">
      <img src="/Images/Icons/nima_10.jpeg" alt="Nima 10" />
    </a>
    <p>Registered member of Nima 10</p>
    <a href="#" rel="noreferrer" className="cred-link">
      View Details →
    </a>
  </div>
</div>

</div>

      {/* <div className="footer-Affiliations">
        <span className="footer-Text">Affiliations</span>
        <span><img src="/Images/tour/members.png" alt="" /></span>
      </div> */}
    <footer className="footer-main">
      <div className="container">
        <div className="row gy-4">

          {/* ABOUT */}
          <div className="col-lg-3 col-md-6">
            <h5>Plenary Holidays</h5>
            <img src="/Images/tour/logo.png" alt="Logo" />
            <p className="footer-desc">
              Plenary Holidays is a full-service travel company in India offering leisure travel, inbound tours, MICE, and corporate travel management services worldwide.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-3 col-md-6">
            <h5>Quick Links</h5>
            <ul className="footer-links two-col">
              <li><Link to="/faqs">FAQ's</Link></li>
              <li><Link to="/about-plenary-holidays">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/travel-tips">Travel Tips</Link></li>
              <li><Link to="/plenaryholidays-certificates">Certificates</Link></li>
              {/* <li><Link to="#">Holiday Packages</Link></li> */}
              {/* <li><Link to="#">Destination Guide</Link></li> */}
              <li><Link to="/csr">CSR</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
              <li><Link to="/testimonial">Testimonial</Link></li>
              <li><Link to="/sitemap">Sitemap</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              {/* <li><Link to="#">Announcement</Link></li> */}
            </ul>
          </div>

          {/* MORE LINKS */}
          <div className="col-lg-3 col-md-6">
            <h5>More</h5>
            <ul className="footer-links">
              {/* <li><Link to="#">GST Registration (New)</Link></li> */}
              {/* <li><Link to="#">Register for Updates</Link></li> */}
              {/* <li><Link to="#">Blog</Link></li> */}
              {/* <li><Link to="#">Sitemap</Link></li> */}
              <li><Link to="job-career">Job/Career</Link></li>
              {/* <li><Link to="#">Downloads</Link></li> */}
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/gst-registration">GST Registration</Link></li>
              <li><Link to="/other-businesses">Other Businesses</Link></li>
              <li><Link to="/payment">Payment</Link></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="col-lg-3 col-md-6 footer-getInTouch">
            <h5>Get In Touch</h5>
            <div className="footer-contact">
              <p>
                <span ><FaLocationDot className="footer-Icons"/></span>311, H-4, Vardhman North Ex-Plaza <br />
                Netaji Subhash Place, Pitampura <br />
                Delhi – 110034
              </p>

              <p>
                <span ><FaPhoneAlt className="footer-Icons"/></span> <a href="tel:+919560321110">+91-9560321110</a><br />
                <span ><FaWhatsapp className="footer-Icons"/></span> <a href="tel:+919555432221">+91-9555432221</a>
              </p>

              <p>
                <span ><IoMailOpenOutline className="footer-Icons"/></span> <a href="mailto:plenaryholidays@gmail.com">plenaryholidays@gmail.com</a><br />
                <span ><IoMailOpenOutline className="footer-Icons"/></span><a href="mailto:mail@plenaryholidays.com">mail@plenaryholidays.com</a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </footer>
    </div>
  );
};

export default FooterSection;
